<div class="d-flex align-items-center body-img-container" [id]="id">
    <div class="p-2 flex-fill">
        <img [src]="utubeIcon" alt="utube" class="utube-icon">
    </div>
</div>

<div class="utube-card-description-txt">
    {{descriptionText | translate}}
</div>